import cloneDeep from 'lodash/cloneDeep';
import { stripFeePromoFromSpecialHourSlot } from '@lib/common';
import { RootStore } from '../../../../../mobx/store';

function sanitizeSpecialHourSlot(
	slot: T.Core.Business.BusinessSpecialHoursSlot
): T.Core.Business.BusinessSpecialHoursSlot {
	return stripFeePromoFromSpecialHourSlot(slot);
}

type SpecialHoursUpdateResponse = { outcome: number; message?: string };

async function persistSpecialHours(
	store: RootStore,
	special_hours: T.Core.Business.BusinessSpecialHours
): Promise<SpecialHoursUpdateResponse> {
	const r = store.restaurant!;
	const res = await store.api.restaurant_update({
		_id: r._id!,
		update: { $set: { 'location.special_hours': special_hours } },
	});
	if (res.outcome) {
		return { outcome: 1, message: res.message };
	}
	store.updateRestaurant({
		location: {
			...r.location,
			special_hours,
		},
	});
	return { outcome: 0 };
}

export async function addSpecialHour(
	store: RootStore,
	slot: T.Core.Business.BusinessSpecialHoursSlot
): Promise<SpecialHoursUpdateResponse> {
	const r = store.restaurant!;
	const special_hours = [...(r.location.special_hours || []), sanitizeSpecialHourSlot(slot)];
	return persistSpecialHours(store, special_hours);
}

export async function editSpecialHour(
	store: RootStore,
	slot: T.Core.Business.BusinessSpecialHoursSlot,
	index: number
): Promise<SpecialHoursUpdateResponse> {
	const r = store.restaurant!;
	const special_hours = cloneDeep(r.location.special_hours || []);
	special_hours[index] = sanitizeSpecialHourSlot(slot);
	return persistSpecialHours(store, special_hours);
}

export async function duplicateSpecialHour(
	store: RootStore,
	slot: T.Core.Business.BusinessSpecialHoursSlot,
	index: number
): Promise<SpecialHoursUpdateResponse> {
	const r = store.restaurant!;
	const special_hours = cloneDeep(r.location.special_hours || []);
	special_hours.splice(index + 1, 0, sanitizeSpecialHourSlot(slot));
	return persistSpecialHours(store, special_hours);
}

export async function deleteSpecialHour(
	store: RootStore,
	index: number
): Promise<SpecialHoursUpdateResponse> {
	const r = store.restaurant!;
	const special_hours = [...(r.location.special_hours || [])];
	special_hours.splice(index, 1);
	return persistSpecialHours(store, special_hours);
}
